import React from 'react';

export const name = 'flag-NR';

export const FlagNR = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_18)">
      <g mask="url(#mask0_1_18)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#0052B4"
        />
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#FFDA44"
        />
        <path
          d="M12 0C8.99859 0.000315162 6.10622 1.12538 3.89351 3.15329C1.68078 5.18119 0.308327 7.96467 0.046875 10.9547H23.9531C23.6917 7.96467 22.3192 5.18119 20.1065 3.15329C17.8938 1.12538 15.0014 0.000315162 12 0ZM12 24C15.0014 23.9997 17.8938 22.8746 20.1065 20.8467C22.3192 18.8188 23.6917 16.0353 23.9531 13.0453H0.046875C0.308327 16.0353 1.68078 18.8188 3.89351 20.8467C6.10622 22.8746 8.99859 23.9997 12 24Z"
          fill="#0052B4"
        />
        <path
          d="M9.91406 16.1719L8.56875 16.8047L9.28594 18.1079L7.82344 17.8266L7.63594 19.3032L6.62344 18.2204L5.60625 19.3032L5.41875 17.8313L3.96094 18.1126L4.67813 16.8047L3.32812 16.1719L4.67344 15.5438L3.95625 14.2407L5.41406 14.5219L5.60156 13.0454L6.61875 14.1282L7.63594 13.0454L7.82344 14.5172L9.27656 14.236L8.56406 15.5438L9.91406 16.1719Z"
          fill="#EEEEEE"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_18">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
